let fallbackSequence = 0;

const readClientLineId = (item) =>
  String(item?.client_line_id ?? item?.clientLineId ?? "").trim();

export const createDraftClientLineId = () => {
  const cryptoSource =
    typeof window !== "undefined" ? window.crypto : undefined;
  const uuid = cryptoSource?.randomUUID?.();
  if (uuid) return `draft-${uuid}`;

  fallbackSequence += 1;
  return `draft-${Date.now().toString(36)}-${fallbackSequence.toString(
    36,
  )}-${Math.random().toString(36).slice(2, 10)}`;
};

const createUniqueId = (usedIds, createId) => {
  let candidate = "";
  do {
    candidate = String(createId());
  } while (!candidate || usedIds.has(candidate));
  usedIds.add(candidate);
  return candidate;
};

export const ensureDraftLineIds = (
  items = [],
  { createId = createDraftClientLineId, usedIds = new Set() } = {},
) =>
  (Array.isArray(items) ? items : []).map((item) => {
    if (!item || item.order_item_id || item.orderItemId) return item;

    const existingId = readClientLineId(item);
    const clientLineId =
      existingId && !usedIds.has(existingId)
        ? (usedIds.add(existingId), existingId)
        : createUniqueId(usedIds, createId);

    if (
      item.client_line_id === clientLineId &&
      item.clientLineId === clientLineId
    ) {
      return item;
    }
    return {
      ...item,
      client_line_id: clientLineId,
      clientLineId: clientLineId,
    };
  });

export const mergeDraftLines = (
  targetItems = [],
  sourceItems = [],
  { createId = createDraftClientLineId } = {},
) => {
  const usedIds = new Set();
  const target = ensureDraftLineIds(targetItems, { createId, usedIds });
  const source = ensureDraftLineIds(sourceItems, { createId, usedIds });
  return [...target, ...source];
};

export const findDraftLineIndex = (items = [], target, targetIndex = null) => {
  if (!target || !Array.isArray(items)) return -1;

  const byReference = items.findIndex((item) => item === target);
  if (byReference !== -1) return byReference;

  const targetClientLineId = readClientLineId(target);
  if (targetClientLineId) {
    const byClientLineId = items.findIndex(
      (item) =>
        !item?.order_item_id &&
        !item?.orderItemId &&
        readClientLineId(item) === targetClientLineId,
    );
    if (byClientLineId !== -1) return byClientLineId;
  }

  if (target.itemKey) {
    const byItemKey = items.findIndex(
      (item) =>
        !item?.order_item_id &&
        !item?.orderItemId &&
        item?.itemKey === target.itemKey,
    );
    if (byItemKey !== -1) return byItemKey;
  }

  if (
    Number.isInteger(targetIndex) &&
    targetIndex >= 0 &&
    targetIndex < items.length &&
    !items[targetIndex]?.order_item_id &&
    !items[targetIndex]?.orderItemId
  ) {
    return targetIndex;
  }

  return items.findIndex(
    (item) =>
      !item?.order_item_id &&
      !item?.orderItemId &&
      item?.id === target.id,
  );
};
